import { TFunction } from 'i18next';
import { toast } from 'react-toastify';
import toErrorWithMessage from './getErrorMessage';

export const getRequestErrorMessage = (error: unknown, t: TFunction) => {
  const { message } = toErrorWithMessage(error);
  const normalized = message.toLowerCase();

  if (
    normalized.includes('not permitted') ||
    normalized.includes('permission denied') ||
    normalized.includes('forbidden')
  ) {
    return t('common.permissionDenied');
  }

  if (message === 'anErrorOccurred') {
    return t('common.anErrorOccurred');
  }

  return message;
};

export const isClosingActionError = (
  result: unknown
): result is { data: null; error: unknown } =>
  typeof result === 'object' &&
  result !== null &&
  'error' in result &&
  Boolean((result as { error?: unknown }).error);

export const showRequestError = (error: unknown, t: TFunction) => {
  toast.error(getRequestErrorMessage(error, t));
};
